import { getSystemId, getUrlConfigApi, translate } from '../utils/util';
import HttpService from './HttpService';
import * as usersElogAction from '../actions/usersElogAction';

const httpService = new HttpService(getUrlConfigApi(window));

export default class UserValidateService {
    static getUsersElog(vision, callback) {
        const url = `security/${vision}/${getSystemId(window)}/vision`;

        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.get(
                    url,
                    {
                        timeout: process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(usersElogAction.setUsersElog(response.data));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                });
            }
        };
    }
}